import { render } from "./CalendarDayPopover.vue?vue&type=template&id=73279a0a"
import script from "./CalendarDayPopover.vue?vue&type=script&lang=ts"
export * from "./CalendarDayPopover.vue?vue&type=script&lang=ts"
script.render = render

export default script